import { configureStore } from "@reduxjs/toolkit";
import bucketsReducer from "./bucketsSlice";
import bulkUpdateReducer from "./bulkUpdateSlice";
import bulkUploadReducer from "./bulkUploadSlice";
import certificateCustomFieldReducer from "./certificateCustomFieldSlice";
import certificateHistoryReducer from "./certificateHistorySlice";
import certificateLabelReducer from "./certificateLabelSlice";
import certificateRequestReducer from "./certificateRequestSlice";
import certificateReducer from "./certificateSlice";
import commonReducer from "./commonSlice";
import companyGroupReducer from "./companyGroupsSlice";
import contentReducer from "./contentSlice";
import coverLetterReducer from "./coverLetterSlice";
import customerCertificateReducer from "./customerCertificateSlice";
import customerCommentsReducer from "./customerCommentsSlice";
import customerCustomFieldReducer from "./customerCustomFieldSlice";
import customerDuplicateReducer from "./customerDuplicateSlice";
import customerHistoryReducer from "./customerHistorySlice";
import customerLabelReducer from "./customerLabelSlice";
import customerQuickSearchReducer from "./CustomerQuickSearchSlice";
import customerReducer from "./customerSlice";
import exemptionMatrixReducer from "./exemptionMatrixSlice";
import exemptionReasonReducer from "./exemptionReasonSlice";
import exportSearchReducer from "./exportSearchSlice";
import failedAPIReportReducer from "./failedAPIReportSlice";
import globalAdminLogsReducer from "./globalAdminLogsSlice";
import globalValidationReducer from "./globalValidationReportSlice";
import healthCheckReducer from "./healthCheckSlice";
import iamDsReducer from "./iamEnablementSlice";
import invalidReasonReducer from "./invalidReasonSlice";
import missingCertificatesReducer from "./missingCertificatesSlice";
import overviewReducer from "./overviewSlice";
import preferencesReducer from "./preferencesSlice/index";
import productCategoriesReducer from "./productCategoriesSlice";
import regionReducer from "./regionSlice";
import requestReducer from "./requestSlice";
import retailLocationReducer from "./retailLocationSlice";
import retailSettingsReducer from "./retailSettingsSlice";
import retailReducer from "./retailSlice";
import roleManagementReducer from "./roleManagementSlice";
import savedSearchesReducer from "./savedSearchesSlice";
import sessionReducer from "./sessionSlice";
import settingReducer from "./settingsSlice";
import validationReducer from "./validationReportSlice";
import vendorPackagesReducer from "./vendorPackagesSlice";

export const reducer = {
    session: sessionReducer,
    buckets: bucketsReducer,
    certificate: certificateReducer,
    customer: customerReducer,
    preferences: preferencesReducer,
    customerCertificate: customerCertificateReducer,
    customerComments: customerCommentsReducer,
    customerHistory: customerHistoryReducer,
    customerDuplicate: customerDuplicateReducer,
    certificateHistory: certificateHistoryReducer,
    request: requestReducer,
    coverLetter: coverLetterReducer,
    exemptionMatrix: exemptionMatrixReducer,
    overview: overviewReducer,
    common: commonReducer,
    customerQuickSearch: customerQuickSearchReducer,
    content: contentReducer,
    setting: settingReducer,
    savedSearches: savedSearchesReducer,
    exportSearch: exportSearchReducer,
    certificateRequest: certificateRequestReducer,
    bulkUpload: bulkUploadReducer,
    bulkUpdate: bulkUpdateReducer,
    roleManagement: roleManagementReducer,
    vendorPackages: vendorPackagesReducer,
    exemptionReason: exemptionReasonReducer,
    region: regionReducer,
    invalidReason: invalidReasonReducer,
    customerCustomField: customerCustomFieldReducer,
    certificateCustomField: certificateCustomFieldReducer,
    retailLocation: retailLocationReducer,
    retailSettings: retailSettingsReducer,
    certificateLabel: certificateLabelReducer,
    customerLabel: customerLabelReducer,
    healthCheck: healthCheckReducer,
    retail: retailReducer,
    productCategories: productCategoriesReducer,
    failedAPIReport: failedAPIReportReducer,
    globalAdminLogs: globalAdminLogsReducer,
    companyGroups: companyGroupReducer,
    iamDs: iamDsReducer,
    validationReport: validationReducer,
    globalValidationReport: globalValidationReducer,
    missingCertificates: missingCertificatesReducer,
};
export default configureStore({
    reducer,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false,
        }),
});
